import { DataGrid as BaseDataGrid, DataGridProps } from '@mui/x-data-grid';

import { MUIDataGridTranslations } from '~util/index';

type Props = Omit<DataGridProps, 'components' | 'localeText'>;

export default function DataGrid(props: Props) {
	return (
		<BaseDataGrid
			style={{ color: 'white' }}
			disableDensitySelector
			localeText={MUIDataGridTranslations}
			{...props}
		/>
	);
}
